import {
  DISTRIBUTOR_NAME,
  DISTRIBUTOR_HASSUB,
  DISTRIBUTOR_HASSUBRETURN,
  DISTRIBUTOR_SUBRETURNMODE,
  DISTRIBUTOR_LEVEL,
  DISTRIBUTOR_INFO
} from '../mutation-types'
const state = {
  distributorName: '',
  distributorLevel: 0, // 渠道商级次
  hasSub: 1, // 是否有下级渠道商
  hasSubReturn: 1, // 下级渠道商是否返佣
  subReturnMode: 1, // 下级返佣方式，1 现金 2代金券
  distributorInfo: {}
}
const mutations = {
  [DISTRIBUTOR_NAME](state, value) {
    state.distributorName = value
  },
  [DISTRIBUTOR_HASSUB](state, value) {
    state.hasSub = value
  },
  [DISTRIBUTOR_HASSUBRETURN](state, value) {
    state.hasSubReturn = value
  },
  [DISTRIBUTOR_SUBRETURNMODE](state, value) {
    state.subReturnMode = value
  },
  [DISTRIBUTOR_INFO](state, value) {
    state.distributorInfo = value
  },
  [DISTRIBUTOR_LEVEL](state, value) {
    state.distributorLevel = value
  },
}

export default {
  state,
  mutations,
}
